import { useEffect, useRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import IntlTelInput from 'intl-tel-input/react';
import { getError } from '../../../utils/FormError';

import 'intl-tel-input/build/css/intlTelInput.css';
import './InputPhoneIntl.scss';

// Same widget (flag + dial code selector) as the registration page — kept as
// its own field so the plain-text InputPhone used elsewhere isn't affected.
const InputPhoneIntl = ({
  name,
  placeholder = '06 XX XX XX XX',
  validationRules = {},
  defaultCountry = 'ma',
}) => {
  const { control, formState: { errors } } = useFormContext();

  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
    rules: validationRules,
    defaultValue: '',
  });

  const error = getError(errors, name);
  const wrapperRef = useRef(null);
  const itiRef = useRef(null);

  // intl-tel-input closes its country dropdown via its own document "click"
  // listener (bubble phase) — but Modal.js calls stopPropagation() on clicks
  // inside a modal dialog, so that listener never fires there. This
  // capture-phase listener runs before stopPropagation can block it.
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        itiRef.current?.getInstance()?._closeDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => document.removeEventListener('mousedown', handleClickOutside, true);
  }, []);

  return (
    <>
      <div ref={wrapperRef}>
        <IntlTelInput
          ref={itiRef}
          initialValue={value}
          onChangeNumber={onChange}
          initOptions={{
            initialCountry: defaultCountry,
            separateDialCode: true,
            countryOrder: ['ma', 'fr', 'dz', 'tn'],
          }}
          inputProps={{
            name,
            className: `form-control ${error ? 'is-invalid' : ''}`,
            placeholder,
          }}
        />
      </div>
      {error && <div className="invalid-feedback d-block">{error.message}</div>}
    </>
  );
};

export default InputPhoneIntl;
